export class Criterio {
    clasificacion_tipo: string
    asignatura: string
    clasificacion: string

    nombre(): string {
        return this.clasificacion_tipo || this.asignatura || this.clasificacion || "Sin nombre"
    }
}
